import "../styles/upcoming.css"
import Header from '../components/Header';

function Upcoming() {
    return (<>
        <Header />
        <div className="upcoming-main">
            <div className="text-ctr upcoming-page-title"><h2 className="text-left">UPCOMING<br />PERFORMANCES</h2></div>
            <div className="upcoming-content">

                {/*              
                <div className="rotate7 text-ctr upcoming-top"><h2 className="text-right"><span className="diagonal">BROKEN</span><br />SEPTEMBER 26 AT 7:30<br />SOUND IS NAUGHT<br />BUT<br />BROKEN AIR.<br />MUSIC FOR A MIND<br />DISRUPTED.<br />TICKETS <a target="_blank" href="https://www.eventbrite.ca/e/broken-tickets-1612017109569?aff=oddtdtcreator"><span className="diagonal">HERE</span></a></h2></div>
                <div className="upcoming-bottom center-div text-ctr"><h2 className="text-left">THE TWO DEATHS OF OPHELIA<br />JUNE 19TH AT 730 PM<br />THE WATER SPEAKS<br />LET LOVE PULL YOU<br />UNDER<br />TICKETS ARE <a target="_blank" href="http://ophelia.eventbrite.com" ><span className="diagonal">HERE</span></a></h2></div>
            
             */}



                <div className="rotate7 text-ctr upcoming-top"><h2 className="text-right">
                    <span className="diagonal">ALWAYS DARKEST DAWN ALWAYS</span><br />
                    1000 REGRETS UNDER AN EMPTY SKY<br />
                    SCHOENBERG DEZ PRES GLASS DU YUN<br />
                    JAN 16 2026 — 21C FESTIVAL<br />
                    <a target="_blank" href="https://www.rcmusic.com/events-and-performances/the-happenstancers-always-darkest-dawn-always" rel="noreferrer"><span className="diagonal">TICKETS HERE</span></a></h2></div>
                <div className="upcoming-bottom center-div text-ctr">
                    <h2 className="text-left "><span className="diagonal">DIE NACHT/DER MOND </span><br />
                        SHADOWED GESTURES AND THE FACE OF THE MOON<br />
                        SAARIAHO WIDMANN KURTAG ADES<br />
                        FEB 20 AND 28 2026<br />
                        <a target="_blank" href="https://thenight.eventbrite.ca" rel="noreferrer"><span className="diagonal">TICKETS HERE</span></a></h2></div>
            </div>
            <div className="rotate-15 text-ctr upcoming-bottom upcoming-3"><h2 className="text-right">
                <span className="diagonal">THE KING’S GRIEF</span><br />
                THE WOLVES CRY,<br />
                AN END FORETOLD<br />
                ADES WEIR<br />
                DOWLAND KNUSSEN<br />
                NOV 7<br />
                <a target="_blank" href="https://kingsgrief.eventbrite.com" rel="noreferrer"><span className="diagonal">TICKETS HERE</span></a>
            </h2>
            </div>
        </div>
    </>
    )
}


export default Upcoming


